import { Component } from '@angular/core';

@Component({
    selector: 'app-block-ui',
    templateUrl: './block-ui.component.html',
})
export class BlockUiComponent {
    block = false;
    show = false;
}
